import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { FaCalendarPlus } from 'react-icons/fa';
import { Select, DatePicker, Button } from 'antd';
import moment from 'moment';

import { Baseline, MODE, TimePeriod } from 'models/baselines';
import { DateTimeFormat } from 'config/const';
import { ArrowUpDown } from 'components/ArrowUpDown';
import { CompanyBaseline } from '../CompanyBaseline';
import { getCompanyNameFromId } from '../Baselines.helpers';
import { BaselineItemCompanyEditDetailsProps } from '../Baselines.types';
import { BaselineItemTotals } from '../BaselineItemTotals/BaselineItemTotals';
import styles from './BaselineItemDetailsEdit.module.scss';
// import { BaselineTimeline } from '../BaselineTimeline/BaselineTimeline';

export const BaselineItemDetailsEdit = ({
  requestedPeriods,
  companyDropdownList,
  companyDropdownValue,
  onExpandRowHandler,
  updateShift,
  updateDate,
  addNewRange,
  onAddCompanySelectHandler
}: BaselineItemCompanyEditDetailsProps) => {
  const companyDetails = (period: TimePeriod, periodIndex: number) => {
    const { from, to, baselines, isExpanded, totalDay, totalNight } = period;
    return (
      <div className={styles.itemDetailsWrapper} key={from}>
        {!isExpanded ? (
          <div
            data-testid="toExpand"
            className={styles.itemCompanyLineCollapsed}
            role="button"
            tabIndex={0}
            onClick={() => onExpandRowHandler(periodIndex, true, MODE.EDIT)}
            onKeyDown={() => onExpandRowHandler(periodIndex, true, MODE.EDIT)}
            aria-label="button"
          />
        ) : (
          <div
            data-testid="toCollapse"
            className={styles.itemCompanyLineExpanded}
            role="button"
            tabIndex={0}
            onClick={() => onExpandRowHandler(periodIndex, false, MODE.EDIT)}
            onKeyDown={() => onExpandRowHandler(periodIndex, false, MODE.EDIT)}
            aria-label="button"
          />
        )}
        <div key={uuidv4()}>
          <div className={styles.date}>
            <DatePicker
              data-testid="datePickerFrom"
              size="large"
              value={moment(from)}
              format={DateTimeFormat.DatePicker}
              onChange={(date: any) => updateDate(date, periodIndex, 'from')}
              disabledDate={(current) => {
                return (
                  (current && current < moment().add(0, 'day')) ||
                  (current && current > moment(to).subtract(1, 'day'))
                );
              }}
            />
          </div>
          <div className={styles.date}>
            <DatePicker
              data-testid="datePickerTo"
              size="large"
              value={to ? moment(to) : null}
              format={DateTimeFormat.DatePicker}
              onChange={(date: any) => updateDate(date, periodIndex, 'to')}
              disabledDate={(current) => {
                return current && current < moment(from).add(1, 'day');
              }}
            />
          </div>
          {!isExpanded ? (
            <div>
              <BaselineItemTotals period={period} />
            </div>
          ) : (
            <div className={styles.baselineItemVertical}>
              <div>
                <BaselineItemTotals
                  total={{ day: totalDay || 0, night: totalNight || 0 }}
                />
              </div>
              {baselines.map((baseline: Baseline, index: number) => {
                const companyName = getCompanyNameFromId(baseline.companyId);
                return (
                  <CompanyBaseline
                    key={uuidv4()}
                    periodIndex={periodIndex}
                    companyIndex={index}
                    companyName={companyName}
                    night={baseline.night}
                    day={baseline.day}
                    onShiftUpdate={updateShift}
                  />
                );
              })}
              <div className={styles.addCompany}>
                <Select
                  data-testid="addCompany"
                  showSearch
                  style={{ width: '100%' }}
                  onChange={(value: string) => {
                    onAddCompanySelectHandler(periodIndex, value);
                  }}
                  placeholder="Add Company"
                  value={companyDropdownValue}
                  options={companyDropdownList}
                />
              </div>
            </div>
          )}
          <ArrowUpDown isExpanded={isExpanded} />
        </div>
      </div>
    );
  };

  return (
    <div className={styles.baselineItemVertical}>
      {requestedPeriods &&
        requestedPeriods.map((period: TimePeriod, index: number) => {
          return companyDetails(period, index);
        })}

      <Button
        className={styles.addNewRangeButton}
        data-testid="addNewRangeButton"
        type="default"
        icon={<FaCalendarPlus />}
        size="middle"
        onClick={addNewRange}
      >
        Add New Range
      </Button>
      {/* <BaselineTimeline data={requestedPeriods} /> */}
    </div>
  );
};
